module.exports = "pegasus_template/assets/tech/npo_1/103.png";